import {StyledEngineProvider, ThemeProvider} from '@mui/material/styles';
import {PropsWithChildren} from 'react';
import {designSystemTheme} from './theme';

export const DesignSystemProvider = ({children}: PropsWithChildren<{}>) => (
  <StyledEngineProvider>
    <ThemeProvider theme={designSystemTheme}>{children}</ThemeProvider>
  </StyledEngineProvider>
);
